import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-return-id";
import * as z from "zod";

const returnScopedInput = z.object({
  scope: z.literal("return"),
  returnId: z.string().min(1),
  locationId: locationIdFormat.schema,
});

const returnItemScopedInput = z.object({
  scope: z.literal("return_item"),
  returnId: z.string().min(1),
  returnItemId: z.string().min(1),
  sessionItemId: processingSessionItemIdFormat.schema,
  locationId: locationIdFormat.schema,
  workstationId: z.string().optional(),
});

const itemProcessingSessionInput = z.object({
  scope: z.literal("item_processing_session"),
  sessionId: processingSessionIdFormat.schema,
  locationId: locationIdFormat.schema,
  workstationId: z.string().optional(),
});

export const findOrCreateInventoryItemForProcessingSession = {
  name: "findOrCreateInventoryItemForProcessingSession" as const,
  input: z.discriminatedUnion("scope", [
    returnScopedInput,
    returnItemScopedInput,
    itemProcessingSessionInput,
  ]),
  output: z.object({ inventoryItemId: inventoryItemIdFormat.schema }),
};
